function creditCardSecurityCodeValidator({ fieldValues, fields, input, msgs }) {
  const AMEX_CARD = 'AMERICAN_EXPRESS';
  const PAYMENT_CARD = 'PAYMENT_CARD';
  const cardTypeField = fields.appRequest_linkedPaymentCard_cardNetwork;
  const cardType = fieldValues.appRequest_linkedPaymentCard_cardNetwork;
  const fundingMethodField = fields.appRequest_fundingMethod;
  const fundingMethod = fieldValues.appRequest_fundingMethod;

  if (!cardTypeField || !cardType || !fundingMethodField || !fundingMethod) {
    return null;
  }

  const rule = /^\d+$/;
  if (fundingMethod === PAYMENT_CARD) {
    if (rule.test(input)) {
      if (cardType === AMEX_CARD && input && input.length !== 4) {
        if (msgs && msgs.ccCodeAmex) {
          return msgs.ccCodeAmex;
        }
        return 'Please enter the 4 digits on the front of your card';
      }
      if (cardType !== AMEX_CARD && input && input.length !== 3) {
        if (msgs && msgs.ccCodeOther) {
          return msgs.ccCodeOther;
        }
        return 'Please enter the last 3 digits on the back of your card';
      }
    } else {
      if (msgs && msgs.ccCode) {
        return msgs.ccCode;
      }
      return 'Security Code must be numeric digits only';
    }
  }

  return null;
}

export default creditCardSecurityCodeValidator;
